(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 39561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ withErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ErrorFallback.jsx




var ErrorFallback = function ErrorFallback(_ref) {
  var error = _ref.error,
      resetErrorBoundary = _ref.resetErrorBoundary;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full h-screen dark:bg-dark-base bg-light-transparent flex items-center justify-center flex-col space-y-12 dark:text-white",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: error.message
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ButtonSimpleRounded */.Vo, {
      label: "Go back to app",
      onClick: resetErrorBoundary
    })]
  });
};

/* harmony default export */ var components_ErrorFallback = (ErrorFallback);
;// CONCATENATED MODULE: ./components/HOC/withErrorBoundary.jsx



var ComponentWithErrorBoundary = function ComponentWithErrorBoundary(ComponentThatMayError) {
  return (0,react_error_boundary_umd.withErrorBoundary)(ComponentThatMayError, {
    FallbackComponent: components_ErrorFallback,
    onReset: function onReset() {
      window.location.search = "/app";
    },
    onError: function onError(error) {
      var _window$Rollbar;

       true && ((_window$Rollbar = window.Rollbar) === null || _window$Rollbar === void 0 ? void 0 : _window$Rollbar.error(error));
    }
  });
};

/* harmony default export */ var withErrorBoundary = (ComponentWithErrorBoundary);

/***/ }),

/***/ 51697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21627);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var Notification = function Notification(_ref) {
  var type = _ref.type,
      text = _ref.text,
      closeAfter = _ref.closeAfter,
      onClose = _ref.onClose;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (closeAfter) {
      setTimeout(function () {
        onClose && onClose();
      }, closeAfter);
    }
  }, [closeAfter, onClose]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "z-50 w-full fixed flex flex-col items-center justify-center left-0 bottom-4",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "w-1/3",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__/* .NotificationsBasic */ .dP, {
        type: type,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
          children: text || "Error"
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Notification);

/***/ }),

/***/ 51421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12454);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Themed = function Themed(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("light"),
      theme = _useState[0],
      setTheme = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTheme((0,_helpers_theme__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentTheme */ .g)());
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "".concat(theme),
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Themed);

/***/ }),

/***/ 59181:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Errors = {
  ERR_REFUND_ORDER_PROCESSING: "You have already requested a refund for this order",
  ERR_EMPLOYEE_ALREADY_EXISTS: "You already have a staff member with this info",
  ERR_UNAUTHORIZED: "Your credentials have expired, you need to log in again",
  ERR_ACCOUNT_BALANCE_LOW: "You don't have enough balance",
  ERR_ORDER_SETTLEMENT_PROCESSED: "Orders in which the settlement process has started cannot be refunded",
  ERR_LOGIN_CREDENTIALS: "Wrong email or password",
  ERR_PASSWORD_WRONG: "Wrong password",
  ERR_TWO_FA_ALREADY_ENABLED: "2fa already enabled",
  ERR_CONTACT_ID_INVALID: "Contact not found",
  ERR_ADDRESS_NOT_FOUND: "Address not generated yet, please contact support",
  ERR_VALIDATION: "Wrong details provided",
  ERR_EMAIL_NOT_FOUND: "Email not found",
  ERR_TWO_FA_CODE_INVALID: "2FA code is invalid or has expired. Please try again",
  UNKNOWN: "An unknown error occurred. Please try again in a few minutes. If the problem persists contact support",
  SUCCESS_LOGIN_OTP_VERIFICATION_CODE: "We sent a new code to your email address",
  ERR_CODE_ALREADY_SENT: "A code was already sent to your email.",
  ERR_VERIFICATION_CODE_INVALID: "Verification code is invalid or has expired. Please try again",
  VALIDATION_FAILED: "Please verify your email and password",
  ERR_EMAIL_OR_PASSWORD_WRONG: "Please verify your email and password",
  ERR_CAPTCHA_REQUIRED: "Please verify captcha to continue.",
  ERR_INVALID_CAPTCHA: "Invalid captcha",
  ERR_ORDER_REFUND_EXISTS: "This order has already been refunded",
  ERR_PHONE_ALREADY_EXISTS: "Phone number is already in use. Please verify or specify a new phone number.",
  ERR_EMAIL_ALREADY_EXISTS: "Email address is already in use. Please verify or specify a new email.",
  ERR_CUSTOMER_NOT_FOUND: "We could not find this email in our database. Please verify.",
  ERR_CUSTOMER_NAME_INVALID: "Name field can only contain a first and a last name.",
  ERR_TWO_FA_CODE: "2FA code is invalid or has expired. Please try again.",
  ERR_DEPOSIT_ADDRESS_REQUIRED: "Please verify that your deposit address is valid.",
  ERR_ORDER_PROCESSED: "Order with current state can't be refunded",
  ERR_PASSWORDS_NOT_MATCHING: "New passwords do not match. Please verify",
  ERR_AMOUNT_LOW: "Amount is less than minimum required",
  ERR_HAS_UNPAID_INVOICES: "You can't ask for new loan before paying active ones",
  ERR_NO_API_USERS: "You need to activate your API keys. Please contact support@datamynt.zendesk.com",
  ERR_NETWORK_NOT_SUPPORTED: "This network is currently not supported",
  ERR_INVALID_ADDRESS: "Please verify if all the added addresses are valid",
  ERR_ASSET_NOT_SWAPPABLE: "Asset is not swappable",
  ERR_INVOICE_NOT_PAID: "You cannot refund an invoice which is not yet paid",
  ERR_WITHDRAWAL_REQUEST_PENDING: "Withdrawal request can't be processed, while there is a pending withdrawal request",
  ERR_INVOICE_REFUND_EXISTS: "A refund has already been processed for this invoice",
  ERR_EXPORT_REQUEST_EXISTS: "We can't process this request as there is an existing export request",
  ERR_SETTLEMENT_ISSUE: "There is an issue with settlement. Please contact support for more details",
  ERR_FIAT_SETTLEMENT_RATE: "Rates are not available currently. Please contact support for more details",
  ERR_BANK_ACCOUNT: "There is a problem verifying bank account. Please contact support for more details",
  ERR_BANK_ACCOUNT_EXISTS: "Bank account details already exists",
  ERR_SETTLEMENT_AMOUNT: "Settlement amount can be >= 500 NGN and <= 10000000 NGN"
};
/* harmony default export */ __webpack_exports__["Z"] = (Errors);

/***/ }),

/***/ 68627:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var FormikErrorMsgs = {
  required: "This field is required",
  invalidEmail: "This is not a valid email",
  invalidPhone: "This is not a valid phone",
  wrongPassword: "Password needs to be at least 8 characters long and maximum of 24 characters. It also needs to include at least one number, one special character and one uppercase letter.",
  noSpecialChars: "No special chars are allowed in this field"
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikErrorMsgs);

/***/ }),

/***/ 12454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getCurrentTheme; }
/* harmony export */ });
/* unused harmony export setTheme */
var setTheme = function setTheme(theme) {
  if (true) {
    localStorage.setItem('theme', theme);
  }
};
var getCurrentTheme = function getCurrentTheme() {
  if (true) {
    return localStorage.getItem('theme') || "light";
  }

  return "light";
};

/***/ }),

/***/ 59269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59181);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






var useErrorHandling = function useErrorHandling() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      error = _useState[0],
      setError = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var withErrorHandling = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(apiCall) {
      var _len,
          params,
          _key,
          _yield$apiCall,
          data,
          _err$response,
          _err$response$data,
          _err$response2,
          _err$response2$data,
          ignoredErrors,
          statusCode,
          statusMessage,
          _window$Rollbar,
          message,
          _args = arguments;

      return _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              for (_len = _args.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                params[_key - 1] = _args[_key];
              }

              _context.next = 4;
              return apiCall.apply(void 0, params);

            case 4:
              _yield$apiCall = _context.sent;
              data = _yield$apiCall.data;
              setError(null);
              return _context.abrupt("return", {
                data: data,
                error: null
              });

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              // Status codes listed here should be expected errors (i.e wrong password token expiration etc)
              ignoredErrors = ["ERR_UNAUTHORIZED", "ERR_PASSWORD_WRONG", "ERR_LOGIN_CREDENTIALS"];
              statusCode = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.statusCode;
              statusMessage = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response2 = _context.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.statusMessage;

              if (!(statusCode === "ERR_UNAUTHORIZED" || statusCode === "ERR_FORBIDDEN")) {
                _context.next = 18;
                break;
              }

              _context.next = 18;
              return router.push("/login");

            case 18:
              if ( true && (!statusCode || !ignoredErrors.includes(statusCode))) {
                (_window$Rollbar = window.Rollbar) === null || _window$Rollbar === void 0 ? void 0 : _window$Rollbar.error(_context.t0);
              }

              if (false) {}

              message = statusCode === "ERR_INVALID_ADDRESS" ? statusMessage : _components_errors__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[statusCode];
              message && setError(message);
              return _context.abrupt("return", {
                error: {
                  statusCode: statusCode,
                  message: message
                }
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return {
    error: error,
    setError: setError,
    withErrorHandling: withErrorHandling
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useErrorHandling);

/***/ }),

/***/ 67949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21627);
/* harmony import */ var _helpers_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12454);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7258);
/* harmony import */ var reaptcha__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46944);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68627);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var Styles = {
  errorMsg: "text-red-primary text-sm"
};
var validationSchema = yup__WEBPACK_IMPORTED_MODULE_2__.object().shape({
  email: yup__WEBPACK_IMPORTED_MODULE_2__.string(_components_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].invalidEmail */ .Z.invalidEmail).max(255).required(_components_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].required */ .Z.required),
  password: yup__WEBPACK_IMPORTED_MODULE_2__.string().required(_components_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].required */ .Z.required).max(24),
  captcha: yup__WEBPACK_IMPORTED_MODULE_2__.string().required(_components_formikErrorMsgs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].required */ .Z.required)
});

var LoginForm = function LoginForm(_ref) {
  var onSubmit = _ref.onSubmit,
      resetCaptcha = _ref.resetCaptcha;
  var formik = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormik */ .TA)({
    initialValues: {
      email: "",
      password: "",
      captcha: ""
    },
    validateOnChange: false,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
    enableReinitialize: true
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("form", {
    className: "flex flex-col items-center w-3/3 sm:w-2/3 lg:w-2/5 p-8",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "pb-8",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__/* .Logo */ .TR, {
        type: "DmDefaultFullColor",
        color: (0,_helpers_theme__WEBPACK_IMPORTED_MODULE_7__/* .getCurrentTheme */ .g)() === "dark" ? "#ffffff" : "#3D8ECD"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "space-y-4 w-full mb-3",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__/* .InputForm */ .M5, {
          withBg: true,
          roundedFull: true,
          onChange: formik.handleChange,
          name: "email",
          type: "email",
          id: "userEmail",
          placeholder: "Your email*"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: formik.errors["email"] ? Styles.errorMsg : "",
          children: formik.errors["email"]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__/* .InputForm */ .M5, {
          withBg: true,
          roundedFull: true,
          onChange: formik.handleChange,
          name: "password",
          id: "userPassword",
          type: "password",
          placeholder: "Password*"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: formik.errors["password"] ? Styles.errorMsg : "",
          children: formik.errors["password"]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "text-xs w-full mt-0",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "text-highlight text-right pr-2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: "/login/forgot-password",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            children: "Forgot your password?"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "text-xs space-y-4 my-8",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "pl-2 leading-5",
        children: ["By logging in, I accept", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: "/terms",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "text-highlight",
            target: "_blank",
            children: "Data\xA0Mynt's Terms of Use"
          })
        }), "\xA0and", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: "/privacypolicy",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            className: "text-highlight",
            target: "_blank",
            children: "Privacy Policy."
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "w-full flex flex-col items-center mb-6",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(reaptcha__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        theme: (0,_helpers_theme__WEBPACK_IMPORTED_MODULE_7__/* .getCurrentTheme */ .g)(),
        sitekey:  true ? "6LfqUgwcAAAAAAABEclHKp9gQ4Y3b8SXpRRR7ST0" : 0,
        onVerify: function onVerify(captcha) {
          return formik.setFieldValue("captcha", captcha);
        },
        ref: resetCaptcha
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
        className: formik.errors["captcha"] ? Styles.errorMsg : "",
        children: formik.errors["captcha"]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      "data-cy": "loginSubmitBtn",
      className: "w-full",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(datamynt_ui_library__WEBPACK_IMPORTED_MODULE_0__/* .ButtonSimpleRounded */ .Vo, {
        grow: true,
        size: "small",
        onClick: formik.handleSubmit,
        label: "Login"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: "text-xs mt-8",
      children: ["Don't have an account?", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
        className: "text-highlight",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: "/contactus",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            children: "\xA0 Click here to contact us"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LoginForm);

/***/ }),

/***/ 79765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
;// CONCATENATED MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (o);
//# sourceMappingURL=jwt-decode.esm.js.map

// EXTERNAL MODULE: ./helpers/api.js
var api = __webpack_require__(47965);
// EXTERNAL MODULE: ./components/Themed.jsx
var Themed = __webpack_require__(51421);
// EXTERNAL MODULE: ./components/HOC/withErrorBoundary.jsx + 1 modules
var withErrorBoundary = __webpack_require__(39561);
// EXTERNAL MODULE: ./hooks/useErrorHandling.jsx
var useErrorHandling = __webpack_require__(59269);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Notification.jsx
var Notification = __webpack_require__(51697);
// EXTERNAL MODULE: ./pages/login/LoginForm.jsx
var LoginForm = __webpack_require__(67949);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/login/index.jsx















var Login = function Login() {
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      captchaForReset = _useState[0],
      setCaptchaForReset = _useState[1];

  var _useState2 = (0,react.useState)("emailAndPassword"),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      values = _useState3[0],
      setValues = _useState3[1];

  var _useErrorHandling = (0,useErrorHandling/* default */.Z)(),
      error = _useErrorHandling.error,
      setError = _useErrorHandling.setError,
      withErrorHandling = _useErrorHandling.withErrorHandling;

  var SubMapper = {
    "login-otp-access": function loginOtpAccess() {
      return setStep("otpCode");
    },
    "2fa-access": function faAccess() {
      return setStep("2FAuth");
    },
    "unverified-email-access": function unverifiedEmailAccess() {
      router.push("/login/email-verification");
    },
    "web-login": function webLogin() {
      router.push("/dashboard");
    },
    "pending-kyc-access": function pendingKycAccess() {
      router.push("/complete-register");
    },
    "pending-kyc-verification-access": function pendingKycVerificationAccess() {
      return setStep("pendingKyc");
    },
    "reset-password-access": function resetPasswordAccess() {
      router.push("/login/change-password");
    }
  };

  var checkPage = function checkPage() {
    router.push("/login");
    document.title = "login";
  };

  var manageRouter = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _yield$getUserProfile, _error, _jwt_decode, sub;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            router.beforePopState(checkPage);
            _context.prev = 1;
            _context.next = 4;
            return (0,api/* getUserProfile */.et)();

          case 4:
            _yield$getUserProfile = _context.sent;
            _error = _yield$getUserProfile.error;

            if (!_error) {
              router.push("/dashboard");
            }

            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            _jwt_decode = jwt_decode_esm(localStorage.getItem("token")), sub = _jwt_decode.sub;
            SubMapper[sub]();

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  })), [values]);

  var login = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values) {
      var _yield$withErrorHandl, data, error, accessToken, _jwt_decode2, sub;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setValues(values);
              _context2.next = 3;
              return withErrorHandling(api/* apiLoginWithPassword */.jN, values);

            case 3:
              _yield$withErrorHandl = _context2.sent;
              data = _yield$withErrorHandl.data;
              error = _yield$withErrorHandl.error;

              if (!error) {
                _context2.next = 9;
                break;
              }

              captchaForReset.reset();
              return _context2.abrupt("return", false);

            case 9:
              accessToken = data.accessToken;

              if (accessToken) {
                localStorage.setItem("token", accessToken);
                _jwt_decode2 = jwt_decode_esm(accessToken), sub = _jwt_decode2.sub;
                SubMapper[sub]();
              }

              captchaForReset.reset();

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function login(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  function login2fa(_x2) {
    return _login2fa.apply(this, arguments);
  }

  function _login2fa() {
    _login2fa = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(code) {
      var _yield$withErrorHandl2, data, _error2;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(code.indexOf(" ") === -1)) {
                _context3.next = 10;
                break;
              }

              _context3.next = 3;
              return withErrorHandling(api/* apiTwoFa */._$, JSON.stringify({
                code: code
              }));

            case 3:
              _yield$withErrorHandl2 = _context3.sent;
              data = _yield$withErrorHandl2.data;
              _error2 = _yield$withErrorHandl2.error;

              if (!_error2) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return");

            case 8:
              localStorage.setItem("token", data["accessToken"]);
              manageRouter();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _login2fa.apply(this, arguments);
  }

  function loginOtp(_x3) {
    return _loginOtp.apply(this, arguments);
  }

  function _loginOtp() {
    _loginOtp = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(code) {
      var _yield$withErrorHandl3, data, _error3;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(code.indexOf(" ") === -1)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 3;
              return withErrorHandling(api/* apiLoginOtp */.r1, JSON.stringify({
                code: code
              }));

            case 3:
              _yield$withErrorHandl3 = _context4.sent;
              data = _yield$withErrorHandl3.data;
              _error3 = _yield$withErrorHandl3.error;

              if (!_error3) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return");

            case 8:
              localStorage.setItem("token", data["accessToken"]);
              manageRouter();

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _loginOtp.apply(this, arguments);
  }

  function resendOtp() {
    return _resendOtp.apply(this, arguments);
  }

  function _resendOtp() {
    _resendOtp = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return withErrorHandling(api/* apiResendOtp */.Zk);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _resendOtp.apply(this, arguments);
  }

  var Steps = {
    emailAndPassword: /*#__PURE__*/(0,jsx_runtime.jsx)(LoginForm["default"], {
      onSubmit: login,
      resetCaptcha: setCaptchaForReset
    }),
    otpCode: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center justify-center space-y-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        className: "pb-4 text-primary text-center",
        children: "Please enter the one-time login code we sent to your email to continue."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* InputVerificationCode */.im, {
        onCompleted: loginOtp
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-center",
        children: "Didn't get a code?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "text-highlight",
        type: "button",
        onClick: function onClick() {
          return resendOtp();
        },
        children: "Resend"
      })]
    }),
    "2FAuth": /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center justify-center space-y-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        className: "pb-4 text-primary text-center",
        children: "Please enter the two factor authentication code to continue."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* InputVerificationCode */.im, {
        onCompleted: login2fa
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "d-flex mt-2 text-center",
        children: "You can use the app you selected to enable two factor authentication (i.e. Google Authenticator) to get your code."
      })]
    }),
    pendingKyc: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-col items-center justify-center space-y-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Your register info is being processed by our team, we will reach back to you as soon as we have finished our KYC process."
      })
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "bg-light-transparent flex flex-col w-screen h-screen p-8 dark:bg-gray-dashboard text-black dark:text-white justify-center items-center",
    children: [ true && Steps[step], error && /*#__PURE__*/(0,jsx_runtime.jsx)(Notification["default"], {
      onClose: function onClose() {
        return setError(null);
      },
      closeAfter: 2500,
      type: "error",
      text: error
    })]
  });
};

var ThemedLogin = function ThemedLogin() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Themed/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Login, {})
  });
};

/* harmony default export */ var login = ((0,withErrorBoundary/* default */.Z)(ThemedLogin));

/***/ }),

/***/ 64167:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(79765);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69898)


/***/ }),

/***/ 35800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,906,7258,2580,646,5034,7965,9774,2888,179], function() { return __webpack_exec__(64167); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);